import React from "react";
import { View, TouchableOpacity, StyleSheet, Dimensions } from "react-native";
import { useNavigation } from "@react-navigation/native";
import i18n from "../../i18n";
import { Text as CustomText } from "../../utils/fontsLoader";
import { useTheme, MD3Theme } from "react-native-paper";

interface CGUProps {
  buttonStatus: boolean;
  setButtonStatus: (status: boolean) => void;
}

export default function AcceptTherms({ buttonStatus, setButtonStatus }: CGUProps) {
  const navigation = useNavigation();
  const theme = useTheme();
  const styles = stylesGen(theme);

  return (
    <View style={styles.Therms}>
      <TouchableOpacity
        style={styles.button}
        onPress={() => setButtonStatus(!buttonStatus)}
        disabled={false}
      >
        <View style={[styles.outerCircle, buttonStatus && styles.selectedOuterCircle]}>
          {buttonStatus && <View style={styles.innerCircle} />}
        </View>
      </TouchableOpacity>
      <View style={styles.textContainer}>
        <CustomText style={styles.text}>
          {i18n.t("login.acceptCGU1")}{" "}
          <CustomText
            onPress={() => navigation.navigate("Therms")}
            style={{...styles.text, ...styles.underline}}
          >
            {i18n.t("login.acceptCGU2")}
          </CustomText>
        </CustomText>
      </View>
    </View>
  );
}

const stylesGen = (theme: MD3Theme) => StyleSheet.create({
  Therms: {
    width: "90%",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  button: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 10,
  },
  outerCircle: {
    height: 24,
    width: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.colors.onBackground,
    alignItems: "center",
    justifyContent: "center",
  },
  selectedOuterCircle: {
    borderColor: theme.colors.primary,
  },
  innerCircle: {
    height: 14,
    width: 14,
    borderRadius: 7,
    backgroundColor: theme.colors.primary,
  },
  textContainer: {
    flex: 1,
  },
  text: {
    textAlign: "center",
    fontSize: Dimensions.get("screen").height / 40,
    fontFamily: "NotoSans-Light",
  },
  underline: {
    textDecorationLine: "underline",
  },
});
